import { GETConfig, POSTConfig } from "@/types/common.types";
import {
	AddDesignationParams,
	Designation,
	UpdateDesignationParams,
} from "@/types/designation.types";
import axios from "axios";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const addDesignation = async (
	accessToken: string,
	params: AddDesignationParams
) => {
	const response = await axios.post(
		`${server_url}case/adddesignations`,
		params,
		POSTConfig(accessToken)
	);

	return response.data;
};

export const updateDesignation = async (
	accessToken: string,
	params: UpdateDesignationParams
) => {
	const response = await axios.post(
		`${server_url}case/updatedesignation`,
		params,
		POSTConfig(accessToken)
	);
	return response.data;
};

export const getDesignations = async (
	accessToken: string
): Promise<Designation[]> => {
	const res = await axios.get(
		`${server_url}case/getdesignations`,
		GETConfig(accessToken)
	);
	return res.data;
};

export const getSingleDesignation = async (
	insurerid: number,
	accessToken: string
): Promise<Designation> => {
	const res = await axios.get(
		`${server_url}case/getsingledesignation/${insurerid}`,
		GETConfig(accessToken)
	);
	return res.data[0];
};
